import {store} from "../store";
import {IMyProfile, myProfileSlice} from "./myProfileSlice";

export const myProfileStore = {
  // State modifiers
  clearMyProfile: () => {
    store.dispatch(myProfileSlice.actions.clearMyProfileReducer());
  },
  setMyProfile: (profile: IMyProfile) => {
    store.dispatch(myProfileSlice.actions.myProfileReducer({profile}));
  },
  setRequestStatus: (status: "loading" | "error" | "completed") => {
    store.dispatch(myProfileSlice.actions.requestStatusReducer({status}));
  },

  // Getters
  getIsMyProfileReady: (): boolean => {
    return [
      "completed",
      "error",
    ].includes(myProfileSlice.selectors.myProfileRequestStatusSelector(store.getState()) ?? 'not-started');
  },
  getMyProfileEmail: () => myProfileSlice.selectors.myProfileEmailSelector(store.getState()),
  getMyProfileFirstName: () => myProfileSlice.selectors.myProfileFirstNameSelector(store.getState()),
  getMyProfileJoinedAt: () => myProfileSlice.selectors.myProfileJoinedAtSelector(store.getState()),
  getMyProfileLastName: () => myProfileSlice.selectors.myProfileLastNameSelector(store.getState()),
  getMyProfileMembershipIsMember: (): boolean => !!myProfileSlice.selectors.myProfileMembershipSelector(store.getState())?.isMember,
  getMyProfileMembershipIsSongLibraryAccessible: (): boolean => !!myProfileSlice.selectors.myProfileMembershipSelector(store.getState())?.isSongLibraryAccessible,
  getMyProfileSessionId: () => myProfileSlice.selectors.myProfileSessionIdSelector(store.getState()),
  getMyProfileUserId: () => myProfileSlice.selectors.myProfileUserIdSelector(store.getState()),
  getMyProfileUsername: () => myProfileSlice.selectors.myProfileUsernameSelector(store.getState()),
  getRequestStatus: () => myProfileSlice.selectors.myProfileRequestStatusSelector(store.getState()),
}